export function init($name) {
    const holder = $($name);

    if (!holder.length) {
        return;
    }

    const slider = holder.find($name + '-slider');
    const clickItems = holder.find($name + '-item');

    slider.slick({
        dots: false,
        arrows: false,
        infinite: false,
        autoplay: false,
        variableWidth: false,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        swipe: false,
        swipeToSlide: false
    });

    clickItems.bind('mouseenter', function() {
       $(this).parents($name + '-item-parent').addClass('stop-animate');
    });

    clickItems.bind('mouseleave', function() {
       $(this).parents($name + '-item-parent').removeClass('stop-animate');
    });

    clickItems.click(function(e) {
        e.stopPropagation();
        e.preventDefault();

        const slide = $(this).data('item');

        slider.slick('slickGoTo', slide);
    })
}
